import { render } from "./DeclinedVaccineForm.vue?vue&type=template&id=3fd277bf"
import script from "./DeclinedVaccineForm.ts?vue&type=script&lang=js&external"
export * from "./DeclinedVaccineForm.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__